// import React from 'react';
import { Agenda } from 'react-native-calendars';

const ZoneAgenda = (props) => {
  return <Agenda {...props} />;
};

export default ZoneAgenda;
